<div>
	@if (showForm()) {
		@if (edit(); as edit) {
			<nz-tabs>
				<nz-tab nzTitle="Edit Activity">
					<app-setup-wizard-activity-form
						[lessonUuid]="edit.before!.lesson_uuid!"
						[loading]="loading()"
						[edit]="edit.after || edit.before || null"
						(onClear)="onFormClear()"
						(onSubmit)="onFormSubmit($event)"
					></app-setup-wizard-activity-form>
				</nz-tab>
				<nz-tab nzTitle="Add Content">
					<app-setup-wizard-content-form
						[activityUuid]="edit.before!.activity_uuid!"
						[loading]="loading()"
						(onClear)="onFormClear()"
						(onSubmit)="onContentFormSubmit($event)"
					></app-setup-wizard-content-form>
				</nz-tab>
			</nz-tabs>
		} @else {
			<h1>Edit is missing...</h1>
		}
	} @else {
		<div class="top-buttons">
			<button
				nz-button
				nzType="primary"
				(click)="onAdd()"
				class="add-button"
				[disabled]="true"
				nz-tooltip="To add a new activity go to the lesson tab and edit the lesson you want to add the activity to."
			>
				Add
			</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.activities"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-activities-table
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-activities-table>
</div>
